/**
 * @author guan
 * @description 经纬度信息
 *
 */
import Location from '@/component/weather/baidumap/location';
const location = new Location();
const locationMessage = {
    state: {
        locationMessage: location,
    },
    getters: {
        /**
         * @author guan
         * @description 获取位置信息
         * @return Location 返回位置信息
         * @param state locationMessage new Location()
         */
        getLocationMessage: (state: { locationMessage: Location }): Location => {
            return state.locationMessage;
        },
    },
    mutations: {
        /**
         * @author guan
         * @description 设置位置信息
         * @return void
         * @param state locationMessage new Location()
         * @param params 新的位置信息
         */
        setLocationMessage: (state: { locationMessage: Location }, params: Location): void => {
            state.locationMessage = params;
        },
    },
    actions: {},
};
export default locationMessage;
